module.exports = __webpack_public_path__ + "static/img/WeHaveTheRightApproach_Desktop.8f4bc25.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/desktop/landing/WeHaveTheRightApproach_Desktop.svg
// module id = vdZb
// module chunks = 1